import { memo } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Typography, Button as MuiButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SideDoorIcon } from '@client/images/logos/SideDoorIcon';
import { Center } from '../common/Center';

const useStyles = makeStyles({ name: 'FourOhFour' })({
  icon: {
    fontSize: 40,
    margin: '0 auto !important',
  },
});

export const FourOhFour = memo(() => {
  const { classes } = useStyles();

  return (
    <Center>
      <Stack spacing={3}>
        <SideDoorIcon className={classes.icon} />

        <Typography variant="subtitle1">
          Sorry, we can't find that page.
        </Typography>

        <div>
          <MuiButton
            variant="outlined"
            color="info"
            component={Link}
            to="/home"
            id="sda-404-home-button"
            size="large"
          >
            Go Home
          </MuiButton>
        </div>
      </Stack>
    </Center>
  );
});

export default FourOhFour;
